import { cn } from '@/lib/utils';
import { AlertCircleIcon } from '@components/icons/AlertCircleIcon';
import { CheckCircleFilledIcon } from '@components/icons/CheckCircleFilledIcon';
import { LoadingSpinnerIcon } from '@components/icons/LoadingSpinnerIcon';
import type { AsyncTaskState } from '@api/asyncTasks';

const ICON_SIZE = 'size-6';

interface JobStatusIconProps {
  state: AsyncTaskState;
  className?: string;
}

export function JobStatusIcon({ state, className }: JobStatusIconProps) {
  if (state === 'succeeded') {
    return (
      <CheckCircleFilledIcon
        aria-hidden="true"
        className={cn(ICON_SIZE, 'text-confirmed-green', className)}
      />
    );
  }

  if (state === 'failed' || state === 'partial_success') {
    return (
      <AlertCircleIcon
        aria-hidden="true"
        className={cn(ICON_SIZE, 'text-chilli-red', className)}
      />
    );
  }

  if (state === 'pending' || state === 'in_progress') {
    return (
      <LoadingSpinnerIcon
        aria-hidden="true"
        className={cn('size-[14px] text-grey', className)}
      />
    );
  }

  return null;
}
